import React, { useState, useEffect, useRef } from "react";

const PatientDetail = ({
  patientPoolId,
  medicalProgram,
  providers,
  CloseModel,
  SubmitData,
  SaveData,
  loading,
  medicalProgramId,
  consentSignDate,
  lastBillingDate,
  providerid,
  IsNew
}) => {
  const getCurrentDate = () => new Date().toISOString().split("T")[0];

  const [formData, setFormData] = useState({
    patient_pool_id: patientPoolId?.toString() || "",
    medical_program_id: medicalProgramId || "",
    consent_sign_date: consentSignDate || getCurrentDate(),
    provider_id: providerid || "",
    last_billing_date: lastBillingDate || getCurrentDate(),
  });

  const [errors, setErrors] = useState({});
  const formDataRef = useRef(formData);

  // Update ref whenever formData changes
  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      patient_pool_id: patientPoolId || prevState.patient_pool_id,
      medical_program_id: medicalProgramId || prevState.medical_program_id,
      consent_sign_date: consentSignDate || prevState.consent_sign_date,
      provider_id: providerid || prevState.provider_id,
      last_billing_date: lastBillingDate || prevState.last_billing_date,
    }));
  }, [patientPoolId, medicalProgramId, consentSignDate, lastBillingDate, providerid]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formDataRef.current.medical_program_id) {
      newErrors.medical_program_id = "Medical Program is required.";
    }
    if (!formDataRef.current.provider_id) {
      newErrors.provider_id = "Provider is required.";
    }
    if (!formDataRef.current.consent_sign_date) {
      newErrors.consent_sign_date = "Consent Sign Date is required.";
    }
    if (!formDataRef.current.last_billing_date) {
      newErrors.last_billing_date = "Last Billing Date is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const updatedFormData = { ...formDataRef.current };
      if (SubmitData) {
        SubmitData(updatedFormData);
        setTimeout(() => {
          SaveData(updatedFormData);
        }, 500);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="card mt-4 px-2">
      {/* Form Fields */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Provider:</label>
          <select
            name="provider_id"
            value={formData.provider_id}
            onChange={handleChange}
            className="form-select"
            disabled={!IsNew}
          >
            <option value="">Select Provider</option>
            {providers.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.name}
              </option>
            ))}
          </select>
          {errors.provider_id && (
            <span className="text-danger">{errors.provider_id}</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">Medical Program:</label>
          <select
            name="medical_program_id"
            value={formData.medical_program_id}
            onChange={handleChange}
            className="form-select"
            disabled={!IsNew}
          >
            <option value="">Select Medical Program</option>
            {medicalProgram.map((program) => (
              <option key={program.id} value={program.id}>
                {program.name}
              </option>
            ))}
          </select>
          {errors.medical_program_id && (
            <span className="text-danger">{errors.medical_program_id}</span>
          )}
        </div>
      </div>

      {/* Date Fields */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Consent Sign Date:</label>
          <input
            type="date"
            name="consent_sign_date"
            value={formData.consent_sign_date}
            onChange={handleChange}
            className="form-control"
            disabled={!IsNew}
          />
          {errors.consent_sign_date && (
            <span className="text-danger">{errors.consent_sign_date}</span>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">Last Billing Date:</label>
          <input
            type="date"
            name="last_billing_date"
            value={formData.last_billing_date}
            onChange={handleChange}
            className="form-control"
          />
          {errors.last_billing_date && (
            <span className="text-danger">{errors.last_billing_date}</span>
          )}
        </div>
      </div>

      {/* Submit Button */}
      <div className="row">
        <div className="col-12 text-end">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading} // Disables button when loading is true
          >
            {loading ? ( // Show spinner and "Saving..." text
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Save" // Show "Save" when not loading
            )}
          </button>

        </div>
      </div>
    </form>
  );
};

export default PatientDetail;
